/** Formatos comunes de las pantallas de la spec 002. */

/** Cifras en euros con dos decimales, formato español. */
export function euros(valor: number | null | undefined): string {
  if (valor === null || valor === undefined || !Number.isFinite(valor)) return '—'
  return valor.toLocaleString('es-ES', { style: 'currency', currency: 'EUR' })
}

/** `YYYY-MM-DD` → `dd/mm/aaaa` sin pasar por UTC. */
export function fechaCorta(iso: string | null | undefined): string {
  if (!iso) return '—'
  const [a, m, d] = iso.slice(0, 10).split('-')
  return a && m && d ? `${d}/${m}/${a}` : iso
}

/** Hoy en ISO local (`toISOString()` daría UTC y, al oeste de Greenwich, ayer). */
export function hoyIso(ahora = new Date()): string {
  const m = String(ahora.getMonth() + 1).padStart(2, '0')
  const d = String(ahora.getDate()).padStart(2, '0')
  return `${ahora.getFullYear()}-${m}-${d}`
}
